import { useTheme } from 'styled-components';
import { NotificationHistory } from '../../../2_domain/notification/notification';
import Column from '../../core/components/box/column';
import SizedBox from '../../core/components/box/sizedBox';
import { LXCaption } from '../../core/texts/lxText';

interface TimeProps {
  today: Date;
  item: NotificationHistory;
}

const TimeStamp = ({ today, item }: TimeProps) => {
  const theme = useTheme();
  const t = {
    year: today.getFullYear(),
    month: today.getMonth() + 1,
    day: today.getDate(),
    hour: today.getHours(),
    min: today.getMinutes(),
  };
  const i = {
    year: item.createdAt.getFullYear(),
    month: item.createdAt.getMonth() + 1,
    day: item.createdAt.getDate(),
    hour: item.createdAt.getHours(),
    min: item.createdAt.getMinutes(),
  };
  const getDoubleDigit = (time: string) => {
    if (time.length < 2) return '0' + time;
    else return time;
  };

  const makeStamp = () => {
    if (t.year === i.year && t.month === i.month && t.day === i.day) {
      if (t.hour === i.hour)
        return `${t.min - i.min} ${theme.notification.minutesAgo}`;
      else return `${t.hour - i.hour} ${theme.notification.hoursAgo}`;
    } else {
      return `${getDoubleDigit(i.hour.toString())}:${getDoubleDigit(
        i.min.toString()
      )}`;
    }
  };

  return (
    <Column>
      <SizedBox height={10} />
      <LXCaption>{makeStamp()}</LXCaption>
    </Column>
  );
};

export default TimeStamp;
